// extracted by mini-css-extract-plugin
export default {"rating":"Uy-z","numberOfStars":"Vy-z","count":"Wy-z","barGraphSpacing":"Xy-z","barGraph":"Yy-z"};